var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 19.88C15.0411 20.18 14.9411 20.5 14.7111 20.71C14.6186 20.8027 14.5087 20.8762 14.3877 20.9264C14.2668 20.9766 14.1371 21.0024 14.0061 21.0024C13.8751 21.0024 13.7455 20.9766 13.6245 20.9264C13.5035 20.8762 13.3936 20.8027 13.3011 20.71L9.29111 16.7C9.18211 16.5933 9.09922 16.4629 9.04892 16.319C8.99861 16.175 8.98225 16.0213 9.00111 15.87V10.75L4.21111 4.62C4.04872 4.41153 3.97544 4.14726 4.0073 3.88493C4.03915 3.6226 4.17354 3.38355 4.38111 3.22C4.57111 3.08 4.78111 3 5.00111 3H19.0011C19.2211 3 19.4311 3.08 19.6211 3.22C19.8287 3.38355 19.9631 3.6226 19.9949 3.88493C20.0268 4.14726 19.9535 4.41153 19.7911 4.62L15.0011 10.75V19.88ZM7.04111 5L11.0011 10.06V15.58L13.0011 17.58V10.05L16.9611 5H7.04111Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.47d5b374d681dd6400360a7247e9c5ca.svg";
export { ForwardRef as ReactComponent };